"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DomainCommandHandler_1 = require("../Engine/Command/DomainCommandHandler");
const DomainEventHandler_1 = require("../Engine/Event/DomainEventHandler");
class Entity {
    constructor(isService, l, commandCatogory, ch, eventCategory, eh) {
        this._changeRecords = [];
        this._isService = false;
        this._isService = isService;
        this._logger = l;
        this._commandHub = ch;
        this._commandHandler = new DomainCommandHandler_1.DomainCommandHandler(commandCatogory, l, ch);
        this._eventHub = eh;
        this._eventHandler = new DomainEventHandler_1.DomainEventHandler(eventCategory, l);
    }
    get changeRecords() { return this._changeRecords.slice(); }
    get hasChangeRecord() { return this._changeRecords.length > 0; }
    addChangeRecord(cr) {
        this._changeRecords.push(cr);
    }
    clearChangeRecord() {
        this._changeRecords = [];
    }
    async sendCommandAsync(cmd) {
        return await this._commandHub.sendCommandAsync(cmd);
    }
    registerAsyncCommandHandler(cmdName, asyncHandler) {
        this._commandHandler.registerAsyncCommandHandler(cmdName, asyncHandler);
    }
    handleCommand(rtcCmd) {
        this._commandHandler.handleCommand(rtcCmd);
    }
    async handleCommandAsync(rtcCmd) {
        await this._commandHandler.handleCommandAsync(rtcCmd);
    }
    async publishEventAsync(evt, receivers) {
        await this._eventHub.publishAsync(evt, receivers);
    }
    registerAsyncEventHandler(cmdName, asyncHandler) {
        this._eventHandler.registerAsyncEventHandler(cmdName, asyncHandler);
    }
    handleEvent(e) {
        this._eventHandler.handleEvent(e);
    }
    async handleEventAsync(e) {
        await this._eventHandler.handleEventAsync(e);
    }
}
exports.Entity = Entity;
var ChangeOperation;
(function (ChangeOperation) {
    ChangeOperation[ChangeOperation["None"] = 0] = "None";
    ChangeOperation[ChangeOperation["Add"] = 1] = "Add";
    ChangeOperation[ChangeOperation["Update"] = 2] = "Update";
    ChangeOperation[ChangeOperation["Remove"] = 3] = "Remove";
})(ChangeOperation = exports.ChangeOperation || (exports.ChangeOperation = {}));
class ChangeRecord {
    constructor(f, o, v) {
        this._fieldName = f;
        this._operation = o;
        this._value = v;
    }
    toString() {
        // if (_value is byte[]) {
        //     ChangeRecord cr = new ChangeRecord(_fieldName, _operation, "Binary...");
        //     return $"{JsonConvert.SerializeObject(cr, Formatting.None)}";
        // }
        // else {
        //     return $"{JsonConvert.SerializeObject(this, Formatting.None)}";
        // }
        return JSON.stringify(this, null, 4);
    }
    get fieldName() { return this._fieldName; }
    get operation() { return this._operation; }
    get value() { return this._value; }
}
exports.ChangeRecord = ChangeRecord;
//# sourceMappingURL=Entity.js.map